import { blockType } from "../constants";
import { LinkCardSchema } from "../schema";
import { LinksCard } from "../types";

export const create: LinksCard["create"] = (initialConfig) => {
  return LinkCardSchema.parse({
    type: blockType,
    config: {
      ...initialConfig,
      title: initialConfig?.title ?? "New card",
      description: initialConfig?.description ?? "Enter your description here.",
      linkText: initialConfig?.linkText ?? "Link",
      url: initialConfig?.url ?? "https://zapier.com",
    },
  });
};
